export const TrackingTypes = {
  TRACKING_PENDING: "TRACKING_PENDING",
  TRACKING_SUCCESS: "TRACKING_SUCCESS",
  TRACKING_FAIL: "TRACKING_FAIL",
};
